import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { CustomerServiceOutlined } from "@ant-design/icons";
import { NeedHelpChip, NeedHelpExpandedText, NeedHelpFooter, NeedHelpLabel, NeedHelpPhoneLink, } from "./style";
const SUPPORT_PHONE_DISPLAY = "+91 8792241616";
const SUPPORT_PHONE_TEL = "tel:+918792241616";
export const NeedHelpSupport = () => {
    const [tappedOpen, setTappedOpen] = useState(false);
    const chipRef = useRef(null);
    useEffect(() => {
        if (!tappedOpen) {
            return;
        }
        const handlePointerDown = (event) => {
            const target = event.target;
            if (chipRef.current && target && !chipRef.current.contains(target)) {
                setTappedOpen(false);
            }
        };
        document.addEventListener("mousedown", handlePointerDown);
        document.addEventListener("touchstart", handlePointerDown);
        return () => {
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("touchstart", handlePointerDown);
        };
    }, [tappedOpen]);
    return (_jsx(NeedHelpFooter, { children: _jsxs(NeedHelpChip, Object.assign({ ref: chipRef, type: "button", className: tappedOpen ? "is-expanded" : undefined, "aria-expanded": tappedOpen, "aria-label": "Need Help?", onClick: () => setTappedOpen((prev) => !prev) }, { children: [_jsx(CustomerServiceOutlined, { "aria-hidden": true }), _jsx(NeedHelpLabel, { children: "Need Help?" }), _jsxs(NeedHelpExpandedText, { children: ["Need urgent assistance? Please contact our support team at", " ", _jsx(NeedHelpPhoneLink, Object.assign({ href: SUPPORT_PHONE_TEL, onClick: (event) => event.stopPropagation() }, { children: SUPPORT_PHONE_DISPLAY })), "."] })] })) }));
};
export default NeedHelpSupport;
